
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';

interface RatingFilterProps {
  value: string | null;
  onChange: (value: string) => void;
}

export function RatingFilter({ value, onChange }: RatingFilterProps) {
  return (
    <div className="flex items-center gap-4">
      <span className="text-sm text-muted-foreground">Filter by rating:</span>
      <Select value={value || 'all'} onValueChange={onChange}>
        <SelectTrigger className="w-40">
          <SelectValue placeholder="All ratings" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All ratings</SelectItem>
          <SelectItem value="5">5 stars</SelectItem>
          <SelectItem value="4">4 stars</SelectItem>
          <SelectItem value="3">3 stars</SelectItem>
          <SelectItem value="2">2 stars</SelectItem>
          <SelectItem value="1">1 star</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
